import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import useIsMobile from '@/hooks/useIsMobile';

import { tabsItemType } from '../data.d';

import 'swiper/css';

interface TabHeaderProps {
  tabs: tabsItemType[];
  activeTab: string;
  onTabChange: (tab: tabsItemType) => void;
}

const TabHeader: React.FC<TabHeaderProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  const swiperRef = useRef<any>(null);
  const isMobile = useIsMobile();
  const handleTabClick = (tab: tabsItemType, index: number) => {
    onTabChange(tab);

    // 获取当前可视区域的起始和结束索引
    const visibleStart = swiperRef.current?.swiper.activeIndex || 0;
    const visibleEnd = visibleStart + 4;
    if (!isMobile) {
      return;
    }

    // 如果点击的是可视区域最后一个且不是实际最后一个,向后滑动一个位置
    if (index === visibleEnd && index < tabs.length - 1) {
      swiperRef.current?.swiper.slideNext();
    }

    // 如果点击的是可视区域第一个且不是实际第一个,向前滑动一个位置
    if (index === visibleStart && index > 0) {
      swiperRef.current?.swiper.slidePrev();
    }
  };

  return (
    <div className="w-full lg:my-6 lg:w-[900px] lg:rounded-full lg:bg-white lg:p-3 lg:shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)] xl:w-[1008px] xl:p-4">
      <Swiper
        ref={swiperRef}
        slidesPerView={isMobile ? 5 : tabs.length}
        spaceBetween={10}
        className="w-[calc(100%+40px)] lg:w-full [&&]:-ml-5 [&&]:px-5 [&&]:py-6 lg:[&&]:ml-0 lg:[&&]:p-0">
        {tabs.map((tab, index) => (
          <SwiperSlide key={tab.key}>
            <div
              className={`
                cursor-pointer
                rounded-xl
                border-2
                border-white
                px-3
                py-3
                text-center
                leading-normal
                shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)]
                backdrop-blur
                lg:rounded-full
                lg:px-6
                lg:py-3
                lg:shadow-none
                xl:px-6
                xl:py-4
                xl:text-[20px]
                ${
                  activeTab === tab.key
                    ? 'font-bold [&&]:bg-[linear-gradient(90deg,_rgba(255,_83,_83,_0.08)_9%,rgba(109,_56,_251,_0.08)_61%,rgba(0,_157,_255,_0.08)_100%),_linear-gradient(180deg,_rgba(255,_255,_255,_0.7)_0%,rgba(255,_255,_255,_0.95)_105%)]'
                    : 'bg-gradient-to-b from-[rgba(255,255,255,0.45)] to-[rgba(255,255,255,0.6)] font-medium'
                }
              `}
              onClick={() => handleTabClick(tab, index)}>
              <span
                className={`${activeTab === tab.key ? 'bg-gradient-to-r from-[#ff5353] via-[#6d38fb] to-[#009dff] bg-clip-text text-transparent' : ''}`}>
                {tab.year}
              </span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TabHeader;
